// DEPENDECIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Button, Modal, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as roleService from "../../../services/management/roleService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import PayRateValidator from "../../../helpers/validators/PayRateValidator";
import { getInputClasses } from "../../../helpers/helper";

var initialPayRate = {
    id: 0,
    name: '',
    straightPayRate: null,
    otPayRate: null
}

const PayRateListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal } = props;
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPayRate, setSelectedPayRate] = useState(initialPayRate);

    useEffect(() => {
        loadTableData();
    }, [])

    const loadTableData = () => {
        roleService.getRoles().then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const editPayRate = (model) => {
        setSelectedPayRate(model);
        setIsModalOpen(true);
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 15,
                download: false,
                setCellProps: () => ({ style: { width: "20%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <button
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => editPayRate(data[dataIndex])}
                            >
                                Edit
                            </button>
                        </>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Role",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "straightPayRate",
            label: "St. Pay Rate",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => (<p>${data[dataIndex].straightPayRate}</p>)
            }
        },
        {
            name: "oTPayRate",
            label: "OT Pay Rate",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => (<p>${data[dataIndex].otPayRate}</p>)
            }
        }
    ];

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedPayRate(initialPayRate);
        formik.resetForm();
    }

    const savePayRate = (values, setStatus, setSubmitting) => {
        roleService.savePayRate(values.id, values.straightPayRate, values.otPayRate).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            handleModalClose();
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: selectedPayRate,
        validationSchema: PayRateValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            savePayRate(values, setStatus, setSubmitting);
        }
    });

    return (
        <div className="row" >
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>PayRate</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Role
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid`}
                                            name="name"
                                            disabled
                                            {...formik.getFieldProps("name")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    St. Pay Rate
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="Enter St. Pay Rate"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "straightPayRate")}`}
                                            name="straightPayRate"
                                            {...formik.getFieldProps("straightPayRate")}
                                        />
                                    </div>
                                    {formik.touched.straightPayRate && formik.errors.straightPayRate ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.straightPayRate}
                                        </div>
                                    ) : null}
                                </div>

                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    St. Pay Rate
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="Enter Overtime Pay Rate"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "otPayRate")}`}
                                            name="otPayRate"
                                            {...formik.getFieldProps("otPayRate")}
                                        />
                                    </div>
                                    {formik.touched.otPayRate && formik.errors.otPayRate ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.otPayRate}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save
                            {formik.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Pay Rates
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage PayRates
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Cancel
                            </button>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(PayRateListingPage);